import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
// import { Camera } from '@ionic-native/camera/ngx';

import { V2HomePageRoutingModule } from './v2-home-routing.module';
import { V2HomePage } from './v2-home.page';
import { V2TopBarModule } from '../../shared/components/v2/v2-top-bar/v2-top-bar.module';
import { FabModule } from '../../shared/components/v2/fab/fab.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule,
    V2HomePageRoutingModule,
    V2TopBarModule,
    FabModule
  ],
  providers: [
    // Camera
  ],
  declarations: [V2HomePage],
  exports: [V2HomePage]
})
export class V2HomePageModule {}
